/**
 * @module Localizer
 * @param  {object} root window/node global instance
 * @param  {function} factory Localizer factory
 * @return {RepositoryService} Localizer instance
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('Localizer', [
      'statusService',
      'storeService',
      'stagingService',
      'localizationServiceProxy',
      'repositoryService',
      'es6-promise',
      'thd-event-emitter',
      'THDCustomer',
      'deliveryZipcodeService'],
      function(userService, storeService, stagingService, localizationServiceProxy, repositoryService, ES6PromisePolyfill, EventEmitter, thdCustomer, deliveryZipcodeService) {
        return factory(root, userService, storeService, stagingService, localizationServiceProxy, repositoryService, ES6PromisePolyfill, EventEmitter, thdCustomer, deliveryZipcodeService);
      });
  } else {
    root.Localizer = factory(root, userService, storeService, stagingService, localizationServiceProxy, repositoryService, ES6PromisePolyfill, EventEmitter, thdCustomer, deliveryZipcodeService);
  }
})(this, function(root, userService, storeService, stagingService, localizationServiceProxy, repositoryService, ES6PromisePolyfill, EventEmitter, thdCustomer, deliveryZipcodeService) {

  /**
   * ES6 Promise, pollyfills if browser doesn't support ES6
   * @type {function}
   */
  var Promise = Promise || ES6PromisePolyfill.Promise;

  /**
   * PubSub extends EventEmitter functionalities
   */
  var PubSub = function() {};
  EventEmitter.extend(PubSub);

  /**
   * @private
   * @member LocalizerEventEmitter
   * @description An instance of PubSub. Only events pertaining to localizer are registered here.
   * @type {object}
   */
  var LocalizerEventEmitter = new PubSub();

  /**
   * @private
   * @function subscribe
   * @description Allows consumers to subscribe to Localizer events.
   * @param  {array} events  events to be listened to.
   * @param  {object} eventHandler handler to be invoked upon an event/events.
   */
  var subscribe = function(events, eventHandler) {
    LocalizerEventEmitter.on(events, eventHandler);
  }

  /**
   * @private
   * @function unsubscribe
   * @description Allows consumers to unsubscribe from Localizer events.
   * @param  {array} events  events to be listened to.
   */
  var unSubscribe = function(event) {
    LocalizerEventEmitter.off(event);
  }

  /**
   * @private
   * @function publish
   * @description Allow Localizer to publish events to all listerners
   * @param  {array} event event to be pubslhed.
   */
  var publish = function(events) {
    LocalizerEventEmitter.trigger.apply(LocalizerEventEmitter, arguments);
  }

  /**
   * @constant
   * @description GPS timeout in milliseconds
   * @type {Number}
   */
  var timeout = 5000;

  /**
   * @constant
   * @description GPS position accuracy threshold - in meters
   * @type {Number}
   */
  var ACCURACY_THRESHOLD_LOW = 804.672; // 0.5 miles

  /**
   * @constant
   * @description  GPS position accuracy threshold in meters
   * @type {Number}
   */
  var ACCURACY_THRESHOLD_HIGH = 80467.2; // 50 miles

  /**
   * Events triggered by localizer during the localization process cycle
   * @type {Event}
   */
  var event = {
    // success events
    /** @event */
    LOCALIZED_BY_IP: 'localized_by_ip',
    /** @event */
    LOCALIZED_BY_GPS: 'localized_by_gps',
    /** @event */
    LOCALIZED_BY_DEFAULT: 'localize_default',
    /** @event */
    LOCALIZED_BY_STORE: 'localized_by_store',
    /** @event */
    LOCALIZED_STORE_CHANGE_GOOGLE: 'localized_store_change_google',
    /** @event */
    LOCALIZED_STORE_CHANGED: 'localized_store_changed',
    /** @event */
    LOCALIZED: 'localize_complete',
    // error events
    /** @event */
    LOCALIZE_BY_STORE_FAILED: 'localize_by_store_failed',
    /** @event */
    LOCALIZE_BY_IP_FAILED: 'localize_by_ip_failed',
    /** @event */
    USER_DENIED_GPS: 'user_denied_gps',
    /** @event */
    GPS_ERROR: 'gps_error',
    /** @event */
    GPS_TIMEOUT: 'gps_position_aquisition_timeout',
    /** @event */
    DELIVERY_ZIP_UPDATED: 'delivery_zip_updated'
  }

  var userOperations = userService.operations;
  var userStatus = userService.status;
  var workflowMapper = userService.workflowMapper;


  /**
   * @function GetCurrentLocation
   * @private
   * @description Prompts user to share GPS location if browser supports
   *
   * @return {object} promise - Promise<Position>, Promise to resolve the position (geo-location)
   */
  var getCurrentLocation = function() {
    return new Promise(function(resolve, reject) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: timeout });
      } else {
        deferred.reject('Geo location is not supported');
      }
    });
  }

  /**
   * @function IsRequestToSelfLocalize
   * @private
   * @description Checks if request from caller is to self localize (localize by store id)
   * @param  {LocalizerRequest}  request LocalizerRequest with store id.
   * @return {Boolean}  True if request is to self localize.
   */
  function isRequestToSelfLocalize(request) {
    return request && request.storeId;
  }

  function getQueryParameterByName(name) {
    var search = location.search;

    if (search.indexOf(name + '=') !== -1) {
      return search.substr(search.indexOf(name + '=')).split('&')[0].split('=')[1];
    }
  }

  function getStoreCodeFromQueryParams() {
    return getQueryParameterByName('store');
  }

  function isRequestFromGoogle() {
    var storenumber = getQueryParameterByName('g_store');
    return !!storenumber
  }

  /**
   * @function isCanadianStore
   * @description  Checks the local store's country and returns true if canada else false.
   * @param  {Store}  localStore store existing either in US or canada
   * @return {Boolean} Returns true if store exists in canada else false.
   */
  function isCanadianStore(localStore) {
    return localStore.address.country === 'CA';
  }
  var updateDeliveryZipcodeDetails = function (deliveryZipCode, type) {
    deliveryZipcodeService.updateDeliveryZipcodeDetails(deliveryZipCode, type);
    if(deliveryZipCode){
      publish(event.DELIVERY_ZIP_UPDATED);
    }
  }
  /**
   * @function ProcessResponse
   * @private
   * @description Run post localization workflow. <br>
   * 1. Persist user's access network - internal/external/unknown. <br>
   * 2. Persist localization workflow - can be either service side/client workflows. Refer StatusService <br>
   * 3. Persist the localized store <br>
   * 4. Update Analytics about the localization workflow <br>
   * 5. Notify consumers of localization lifecycle events.<br>
   *
   * @param  {Store} localStore - Localized store
   * @param  {String} workflow - Refer StatusService for workflows.
   * @param  {Event} localizationEvent - event to be triggered of the localization life-cycle event.
   * @param {string} localizationMethod Localization method passed by the consumer
   */
  var processResponse = function(localStore, workflow, localizationEvent, localizationMethod) {
    var wasLocalized = userStatus.isLocalized();
    var previouslyLocalizedStore = storeService.getStore();
    userOperations.setLocalizationMode(workflow);

    if (userStatus.isInternal(workflow)) {
      userOperations.markAsInternalUser();
    } else if (userStatus.isExternal(workflow)) {
      userOperations.markAsExternalUser();
    }

    // if accessed from store
    userOperations.markAsInStoreUser(workflow);
    storeService.setStore(localStore);
    
    // sets the workflow for digital-data
    localStorage.setItem('localizationMethod', (localizationMethod || workflowMapper[workflow].alias));

    // sets THD_LOCALIZER
    stagingService.__setTHDLocalizer(localStore, workflow, false);

    // Whenever user is localized to a store, default the store zip code as delivery zip. (for Regional Assorment MVP1)
    // This cookie will be used across .com to calculate assortment and delivery options
    deliveryZipcodeService.updateDeliveryZipcodeOnLocalizationWorkflow(localStore, userStatus.getAccuracy());

    publish(event.LOCALIZED); // generic event
    publish(localizationEvent); // specific event
    var localizationOpts = {
      localStore: localStore,
      workflow: workflow,
      localizationEvent: localizationEvent,
      localizationMethod: localizationMethod || workflowMapper[workflow].alias
    };
    if (typeof window !== 'undefined' && window.THD_EVENT_BUS) {
      window.THD_EVENT_BUS.lifeCycle.trigger('LOCALIZATION.localized', localizationOpts);
    }
    if (wasLocalized && previouslyLocalizedStore.storeId !== localStore.storeId) {
      publish(event.LOCALIZED_STORE_CHANGED);
    }
    if (isRequestFromGoogle() && (wasLocalized && ('0' + previouslyLocalizedStore.storeId).slice(-4) !== localStore.storeId)) {
      publish(event.LOCALIZED_STORE_CHANGE_GOOGLE);
    }
  }

  /**
   * @function HandleGpsError
   * @private
   * @description Handles GPS error
   * If user didn't consent to share location (code==1)
   * publish consumers that user denied to share location.
   * Otherwise publish as generic GPS error.
   *
   * @param  {Error} error Browser navigator current position error
   */
  var handleGpsError = function(error) {
    var errorEvent;
    if(error.code === 1) {
      errorEvent = event.USER_DENIED_GPS;
      userOperations.setGpsStatus('gps access denied');
    } else if(error.code === 3) {
      errorEvent = event.GPS_TIMEOUT;
      userOperations.setGpsStatus('gps timeout');
    } else {
      errorEvent = event.GPS_ERROR;
      userOperations.setGpsStatus('gps error');
    }
    publish(errorEvent);
  }

  /**
   * @function IsAccuracyBetweenThreshold
   * @private
   * @description Checks if the GPS accuracy falls between LOW and MEDIUM accuracy threshold
   * @param  {Position}  position User's latitude, longitude, accuracy
   * @return {Boolean}   True if GPS accuracy is within the LOW-MEDIUM range.
   */
  var isAccuracyBetweenThreshold = function(position) {
    return position.coords.accuracy > ACCURACY_THRESHOLD_LOW && position.coords.accuracy < ACCURACY_THRESHOLD_HIGH;
  }

  /**
   * @function IsCurrentAccuracyMediumOrLow
   * @private
   * @description checks if currently localized accuracy is Medium or Low
   * @return {Boolean} true if current localization accuracy is Medium/Low.
   */
  var isCurrentAccuracyMediumOrLow = function() {
    return userStatus.getAccuracy() === undefined ||
    userStatus.getAccuracy() === 'LOW' || userStatus.getAccuracy() === 'MEDIUM';
  }

  /**
   * @function LocalizeByGPS
   * @private
   * @description GPS: Geo-localize <br>
   * Attempt to localize the user based on users' latitude, longitude and accuracy. Requests localization-service to localize
   * based on user geo-position.<br>
   * 1. If GPS accuracy is within ACCURACY_THRESHOLD_LOW (<0.5 miles) then classify the workflow as GPS_HIGH<br>
   * 2. If GPS accuracy is between ACCURACY_THRESHOLD_LOW and ACCURACY_THRESHOLD_MEDIUM(<50 miles)
   *   and current localization accuracy is Medium/Low then classify workflow as GPS_MEDIUM. <br>
   * 3. If current localization accuracy is Low and GPS accuracy is beyond ACCURACY_THRESHOLD_MEDIUM (>50 miles)
   *  then classify workflow as GPS_LOW.<br>
   * @param  {Position} position User consent GPS information {lat, long, accuracy}
   */
  var localizeByGPS = function(position) {
    userOperations.setGpsStatus('gps access granted');
    localizationServiceProxy.getLocalStore(position.coords)
      .then(function(localizationResponse) {
        if(isCanadianStore(localizationResponse.localStore)) {
          userOperations.markAsCanadianUser();
          processResponse(storeService.getDefaultStore(), 'LOCALIZED_BY_DEFAULT', event.LOCALIZED_BY_DEFAULT);
        } else {
          var workflow;
          if (position.coords.accuracy <= ACCURACY_THRESHOLD_LOW) {
            workflow = 'LOCALIZED_BY_GPS_HIGH';
          } else if (isAccuracyBetweenThreshold(position) && isCurrentAccuracyMediumOrLow()) {
            workflow = 'LOCALIZED_BY_GPS_MEDIUM';
          } else if (userStatus.getAccuracy() === 'LOW') {
            workflow = 'LOCALIZED_BY_GPS_LOW';
          }
          processResponse(localizationResponse.localStore, workflow, event.LOCALIZED_BY_GPS);
        }
      });
  }

  /**
   * @function LocalizeByIP
   * @private
   * @description AUTO-LOCALIZE: Attempts to localize the user based on IP. Requests localization-service to localize user based on IP.<br>
   *  1. Mark user as auto localized.<br>
   *  2. Mark user as INTERNAL if workflow is among [known,store,default-internal] else External or Unknown user.<br>
   *  3. Set localized store based on the user's past ip history, Akamai's geo guess, subnet or known ip, store ip.<br>
   *  4. Notify consumers that user has been localized by IP.<br>
   * If localization-service fails to respond or localize. Notify of the failure and default localize the user
   *
   * @return {Promise} - A promise wrapper with LocalizerResponse, Promise<LocalizerResponse>
   */
  var localizeByIp = function(resolve, reject) {
    localizationServiceProxy.getLocalStore() // get the closest store near to my location.
      .then(function(localizationResponse) {
        /*
          If there is a race condition, then subsequent request might escape isLocalization condition.
          An additional check eliminates further updates on auto localization.
         */
        if(userStatus.isLocalized()) {
           resolve(localizerResponse);
        } else {
          if(isCanadianStore(localizationResponse.localStore)) {
            userOperations.markAsCanadianUser();
            // default to 121 to all canadian users
            processResponse(storeService.getDefaultStore(), 'LOCALIZED_BY_DEFAULT', event.LOCALIZED_BY_DEFAULT);
          } else {
            processResponse(localizationResponse.localStore, localizationResponse.metadata.workflow, event.LOCALIZED_BY_IP);
          }
          resolve(localizerResponse);
          promptUserToShareGpsLocation(); // Check if user wishes to share his/her location
        }
      }, function(error) {
          publish(event.LOCALIZE_BY_IP_FAILED);
          processResponse(storeService.getDefaultStore(), 'LOCALIZED_BY_DEFAULT', event.LOCALIZED_BY_DEFAULT);
          resolve(localizerResponse);
      });
  }

  /**
   * @function LocalizeByStore
   * @private
   * @description SELF-LOCALIZE: Attempts to localize based on store ID. <br>
   * Requests localization-service for store details for the given store ID.<br>
   * 1. Marks the user as self localized. <br>
   * 2. Set the localized store with retrieved store details.<br>
   * 3. Trigger an event indicating that user has been localized to the store requested.<br>
   *
   * @param  {LocalizationRequest} request - LocalizationRequest with store ID.
   * @param {string} workflow - Default workflow for localize by store
   * @return {Promise} - A promise wrapper with LocalizerResponse, Promise<LocalizerResponse>
   */
  var localizeByStore = function(request, workflow) {
    return new Promise(function(resolve, reject) {
      localizationServiceProxy.getStoreFromSSS(request.storeId)
        .then(function(localizationResponse) {
          if(localizationResponse.stores[0]) {
            processResponse(localizationResponse.stores[0], workflow||'LOCALIZED_BY_STORE',
              event.LOCALIZED_BY_STORE, request.localizationMethod);
            resolve(localizerResponse);
          }
        },function(error) {
          publish(event.LOCALIZE_BY_STORE_FAILED);
          reject(localizerResponse);
        });
    });
  }

  /**
   * @function PromptUserToShareGpsLocation
   * @private
   * @description Prompt the user to share his/her geo location (lat,long,accuracy)
   * If user consents then localize by GPS else Notify consumers and take no action.
   */
  var promptUserToShareGpsLocation = function() {
    if(!userStatus.isRequestFromConsumerApp()){
      getCurrentLocation().then(localizeByGPS, handleGpsError);
    }
  }

  /**
   * @function checkForStoreNumberForUserInsideStore
   * @private
   * @description geti the store number if a user is inside of a store when accessing HD.com
   *
   * @param  {Position} this will provide the coordinates for the endpoint to get which store number the user is in
   */
  var checkForStoreNumberForUserInsideStore = function(position, window) {
    return new Promise(function(resolve, reject) {
      var storeNumber = "Not In Store";
      var latitude = position !==null ? position.coords.latitude : resolve(storeNumber);
      var longitude = position !==null ? position.coords.longitude : resolve(storeNumber);
      var radius = "0.135531538772583";
      var url = window.location.origin + "/StoreSearchServices/v2/storesearch?radius=" + radius + "&latitude=" + latitude +"&longitude=" + longitude + "&type=json&pagesize=20";
      if(position !==null){
        var resultFromApi = localizationServiceProxy.getNearestStoreByRadius(radius, latitude, longitude);
        try{
          resultFromApi.then(function(response){
            if (response.stores){
              storeNumber = response.stores[0].storeId;
            }
            resolve(storeNumber);
          });
        }
        catch(error){
          reject(new Error(error));
        }
      }

    })
  }

  var setStoreNumber = function (storeNumber){
    return userOperations.setStoreNumberIfUserIsInsideStore(storeNumber);
  }

  var setDeliveryZipIfNotPresent = function (localizerResponse) {
   deliveryZipcodeService.updateDeliveryZipcodeFromLocalizerResponse(localizerResponse);
  }

  var getStoreHours = function (localizerResponse) {
    var storeId = localizerResponse.getLocalizedStore().storeId;
    if(!storeHoursPromise) {
      storeHoursPromise =  new Promise(function (resolve, reject) {
        localizationServiceProxy.getStoreFromSSS(storeId)
         .then(function (response) {
           try {
            var storeSearchResponse = (response && response.stores) ? response.stores[0] : null;
            storeService.setStoreHours(storeSearchResponse);
            stagingService.__setStoreHours(storeSearchResponse); /*  Will uncomment when HFApp bumps up to recent localizer */
           }catch (e) {
            console.error("Error in setting store hours from SSS reponse " + e);
           }

           resolve(localizerResponse);
          }, function(error){
            reject(error);
          });
      });
    }
    return storeHoursPromise;
  }

  var setTHDLocalizerIfLoggedIn = function(localizerResponse){
    if((thdCustomer.default.isLoggedIn || thdCustomer.default.isPersisted) && localizerResponse){  
      stagingService.__setTHDLocalizer(localizerResponse.getLocalizedStore(), localizerResponse.status.getWorkflow(), true);
    }
  }
  /**
   * get user location at every fixed time interval (equals cookie expiry) to determine if user is in store
   */
  var hasCookie = userService.status.getSessionToPreventUserInStoreCall();
  if (!hasCookie && !userStatus.isRequestFromConsumerApp()) {
    userOperations.setSessionToPreventUserInStoreCall();
    getCurrentLocation().then(function(position) {
      checkForStoreNumberForUserInsideStore(position, window)
        .then(function(storeNumber) {
          setStoreNumber(storeNumber)
        });
    });
  }

  /**
   * Localizer Response
   * @type LocalizerResponse
   */
  var localizerResponse = {

    status: userService.status,

    getLocalizedStore: function() {
      return storeService.getStore();
    },

    getUserStore: function() {
      return storeService.getUserStore();
    }
  };

  /**
   * Cache auto localize promise if multiple `localize()` calls are made
   * before the first one resolves
   */
  var autoLocalizePromise;
  var storeHoursPromise;

  /**
   ************** REMOVE THIS CLOSURE POST MIGRATION *************
   * This code is relevant only until migration to standardized localizer
   * This closure will be removed once all consumers migrate to new localizer.
   * This is to handle specific scenario like below:
   * Homepage is using old localizer and the user self localizes.
   * User navigates to PIP. PIP is using new localizer. since 'WORKFLOW' will not be present
   * in local storage, PIP reruns the localize again. So a self localized user will be
   * updated with a different store based on auto-localization in PIP page.
   *
   * To avoid this, workflow will be set on loading the new localizer module.
   * Now when PIP loads new localizer module, workflow will be set based on the existing
   * values set by the old localizer.
   *
   */
  (function() {

    /*
     * **** This code should be either in Header header.myaccount.js or MyAccount module ****
     * A work around for My Account. This method listens to updateUserStatus event
     * triggered by MyAccount. Upon user sign in this event is triggered. And user
     * should be updated to User's preferred store configured in his/her profile.
     * @param  {string} event name - updateUserStatus
     * @param {Function} event handler to localize by preferred store.
     */
    document.addEventListener('updateUserStatus', function() {
      var store = storeService.getStore();
      if(!!store) {
        var localizerRequest = { storeId: store.storeId, localizationMethod: 'my account sign-in' };
        localizeByStore(localizerRequest);
      }
    });

    function doWorkflowExists() {
      var workflow = userService.status.getWorkflow();
      return !!workflow;
    }

    var aliasToWorkflow = {
      'IP-DB:Corporate': 'KNOWN_LOCATION',
      'IP-DB:Store': 'THD_STORE_LOCATION',
      'IP-DB:History': 'LOC_HISTORY_BY_IP',
      'Default': 'DEFAULT',
      'IP-DB:Default Internal': 'DEFAULT_INTERNAL',
      'IP-DB:Vendor': 'GEO_LOCATION',
      'IP-DB:Similar History': 'LOC_HISTORY_BY_SUBNET',
      'ESVS:Store': 'THD_STORE_LOCATION',
      'in store access': 'THD_STORE_LOCATION',
      'change store overlay': 'LOCALIZED_BY_STORE'
    };
    // WORKFLOW doesn't exist (will not exist when localizer is loaded for first time
    // & yet to be localized Or consumers are using old localizer)
    if(!doWorkflowExists()
      // THD_FORCE_LOC is set
      && (userService.status.isSelfLocalized()
      || userService.status.isAutoLocalized()
      || userService.status.isDefaultLocalized()
      // THD_LOCSTORE is set
      || storeService.getStore())) {
      // THD_FORCE_LOC or THD_LOCSTORE are set without WORKFLOW, then it is guaranteed
      // that consumers are loading old localizer
      var localizationMethod = userStatus.__getLegacyLocalizationMethod();
      if(localizationMethod) {
        var workflow = aliasToWorkflow[localizationMethod] || 'LOCALIZED_BY_STORE';
        userOperations.setWorkflow(workflow);
        /*
        * There is change in definition of self localization.
        * Only iff user makes decision on store then its treated as self localization.
        * This corrects that definition for those using old localizer.
        */
        userOperations.setLocalizationMode(workflow);
      }
      /* 1. User lands on homepage and new localizer is run. workflow created.
       * 2. User navigates to PLP/PIP (using old localizer), and then self localizes using localization overlay.
       *    Localizer internal state is updated. But workflow is not updated.
       * 3. User navigates back to homepage (using standardized localizer) - WORKFLOW is updated.
       */
      else if(doWorkflowExists() & userService.status.isSelfLocalized()) {
          var workflow = userService.status.getWorkflow();
          var localizationMethod = userStatus.__getLegacyLocalizationMethod();
          if(workflow !== 'LOCALIZED_BY_STORE') {
            if(localizationMethod === 'change store overlay' ) {
              // Self localized on page (using old localizer). Hence updating the workflow
              userOperations.setWorkflow('LOCALIZED_BY_STORE');
            } else {
              // PIP changed localization mode in the backend. Updating in accordance with workflow.
              userOperations.setLocalizationMode(workflow);
            }
          }
      }
    }
  })();


  return {

    /**
     * @member events that localizer triggers
     * @type {Event}
     * @example
     * Localizer.on(Localizer.event.LOCALIZED, function(){})
     */
    event: event,

    /**
     * @member {Status} status - Status instance with methods to check the localization status.
     * Status indicating the mode of localization
     * @example
     * Localizer.status.isSelfLocalized()
     * @type {UserService.Status}
     */
    status: userService.status,

    /**
     * @member {Staging} THD_LOCALIZER - Consolidates all localizer ralted cookie.
     * @example
     * Localizer.__getTHDLocalizer();
     */
    __getTHDLocalizer: stagingService.__getTHDLocalizer,
    __getExistingLocalizer: stagingService.__getExistingLocalizer,

    checkForStoreNumberForUserInsideStore: checkForStoreNumberForUserInsideStore,
    updateDeliveryZipcodeDetails: updateDeliveryZipcodeDetails,
    getDeliveryZipcodeDetails: deliveryZipcodeService.getDeliveryZipcodeDetails,
    getDeliveryZipcodeType: deliveryZipcodeService.getDeliveryZipcodeType,
    validateUSZipcode: deliveryZipcodeService.validateUSZipcode,
    /**
     * @function localize
     * @description  Allows user to either<br>
     * 1. Set the preferred store. <br>
     * 2. Set the closest store. <br>
     * 3. Set the defaults store #121
     *
     * @param {LocalizerRequest} request - Optional LocalizerRequest with storeId attribute
     * @example
     * 1. Localizer.localize({storeId: 121, localizationMethod:'Store finder'})
     * 2. Localizer.localize()
     * @fires  LOCALIZED
     * @return {Promise} promise - Promise wrapping Localizer Response
     */
    localize: function(request) {
      var storeId;  
      try {
        storeId = +getStoreCodeFromQueryParams();
      } catch(e) {
        storeId = null;
      }

      // REFRESH Existing Cookies
      userStatus.refreshCookies();

      // GOOGLE LIA AD localize
      if (storeId) {
        return localizeByStore({storeId: storeId});
      }
      // Self localize
      if (isRequestToSelfLocalize(request)) {
        return localizeByStore(request);
      }

      // Already localized
      if (userStatus.isLocalized()) {

      /*
			*  Copy from PERSIST if user is logged in
			*/
        // setTHDLocalizerIfLoggedIn(localizerResponse);
        setDeliveryZipIfNotPresent(localizerResponse);
        
        if (userStatus.isStoreHoursExpired()) {
          getStoreHours(localizerResponse).then(function () {
            return Promise.resolve(localizerResponse);
          }, function(error) {
            return Promise.resolve(localizerResponse);
          });
        } else {
          return Promise.resolve(localizerResponse);
        }
      }

      // Auto localize
      if (!autoLocalizePromise) {
        if(userStatus.isLocalized()){
          return storeHoursPromise ? storeHoursPromise : Promise.resolve(localizerResponse);
        }
        autoLocalizePromise = new Promise(localizeByIp);
      }

      return autoLocalizePromise;
    },

    /**
     * @function localizeFuzzy
     * @description Localizes user to the store ID passed provided <br>
     * the current existing accuracy is MEDIUM or LOW. It means that <br>
     * if user is auto/self/default localized with MEDIUM or LOW accuracy<br>
     * then override by self localizing the user again with the given store ID.
     * else resolve with the already localized store.<br>
     *
     * Note: This API should be used when caller is fuzzy about localizing
     * the user for the given store ID.
     * @example
     * Localizer.localizeFuzzy({storeId: 154, localizationMethod:'Store finder'});
     * @fires LOCALIZED
     * @param  {LocalizerRequest} request - Mandatory, LocalizerRequest with storeId attribute
     * @return {Promise} promise - Promise wrapping Localizer Response
     */
    localizeFuzzy: function(request) {
      if(isCurrentAccuracyMediumOrLow()) {
        return localizeByStore(request, 'LOCALIZED_BY_FUZZY_STORE');
      }
      return Promise.resolve(localizerResponse);
    },

    /**
     * @function GetLocalizedStore
     * @readOnly
     * @description Returns of the localized store.
     * @return {Store} store Localized Store
     */
    getLocalizedStore: function() {
      return storeService.getStore();
    },


    /**
     * @function getUserStore
     * @description If HD is accessed from one of the store location, this method returns the store
     * from where the user has accessed HD.com
     * @return {object} Store details
     */
    getUserStore: function() {
      return storeService.getUserStore();
    },

    /**
     * @function __onlyUsedForTests
     * @description Re-initializing autoLocalizePromise as null since there will be multiple test in same environment
     *  - This is typically used ONLY FOR UNIT TEST
     */
    __onlyUsedForTests: function() {
      autoLocalizePromise = null;
    },
    /**
     * @function on
     * @description Allows consumers to subscribe to events from Localizer
     * @param  {array} events  Array of events callee wants to listen to.
     * @param  {object} eventHandler Handler to be invoked upon trigger of the event.
     * @example
     * 1. Localizer.on([Localizer.event.LOCALIZED, Localizer.event.LOCALIZED_BY_GPS], eventHandler(){})
     * 2. Localizer.on(Localizer.event.LOCALIZED, eventHandler(){})
     */
    on: function(events, eventHandler) {
      subscribe(events, eventHandler);
    },

    /**
     * @function off
     * @description Allows consumers to unsubscribe to events from Localizer
     * @param  {string} event event to be unsubscribed
     * @example
     * 1. Localizer.off(Localizer.event.LOCALIZED)
     */
    off: function(event) {
      unSubscribe(event);
    }
  }

});



//////////////////
// WEBPACK FOOTER
// ./src/Localizer.js
// module id = 8
// module chunks = 0